<template>
  <div class="buy_class">
    <!-- 顶部文案 -->
    <div class="head">
      <p class="head_p" v-if="ispay==1">您已选择使用0元领取以下课程，请点击【去支付】完成0元领课，如需更换课程请咨询客服</p>
      <p class="head_p" v-else>您已完成0元领课，请前往学而思网校APP点击【学习】查看课程</p>
    </div>
    <!-- 课程卡片 -->
    <div class="card" v-if="getshow">
      <div class="classCard">
        <p class="title_p">{{getcardList.name}}</p>
        <p class="text_p">{{getcardList.schoolTimeName}} · 共{{getcardList.syllabusNum}}讲</p>
        <p class="level_p">
          难度
          <van-rate
            :size="14"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
            :count="getcardList.difficulty.alias"
            v-model="getcardList.difficulty.alias"
          />
        </p>
        <div class="teacher_p">
          <dl class="teacherdl">
            <dt>
              <img :src="getcardList.chineseTeacher[0].avatars" />
            </dt>
            <dd>
              <p class="typename_p">{{getcardList.chineseTeacher[0].typeName}}</p>
              <p class="name_p">{{getcardList.chineseTeacher[0].name}}</p>
            </dd>
          </dl>
          <dl class="teacher_dl">
            <dt>
              <img :src="getcardList.class.counselor.avatars[0]" />
            </dt>
            <dd>
              <p class="typename_p">{{getcardList.class.counselor.typeName}}</p>
              <p class="name_p">{{getcardList.class.counselor.name}}</p>
            </dd>
          </dl>
        </div>
        <div class="pay_box">
          <p class="surplus_p">剩余{{getcardList.class.leftNum}}个名额</p>
          <p :class="['buy_p', {'buy_p_unactive': ispay === 2, 'buy_p_active': ispay===1}]" @click="gopay" v-if="payshow">去支付</p>
          <p class="buy_ok" @click="payok" v-else>支付成功</p>
        </div>
      </div>
    </div>
    <!-- 客服  按钮-->
    <customer-service :position="48" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Rate, Dialog } from 'vant'

import customerService from '../components/customerService'

Vue.use(Rate)
export default {
  name: 'payPage',
  components: {
    'customer-service': customerService
  },
  data() {
    return {
      getcardList: {},
      getshow: false,
      isInApp: false,
      payshow: true,
      ispay: ''
    }
  },
  created() {
    this.getCardList()
  },
  mounted() {
    this.isInApp = this.isApp()
  },
  methods: {
    // 监听返回事件
    // 获取已选课程列表
    async getCardList() {
      const res = await this.$api.getSelectedClass()
      if (res.code === 0) {
        const getSelectedClass = res.data || {}
        this.getcardList = getSelectedClass.courseData
        this.ispay = Number(getSelectedClass.couponStatus)
        this.getshow = true
      } else {
        this.$xesAlert({
          title: '提示',
          message: res.msg,
          sureText: '我知道了',
          type: alert,
          onSure: () => {
            this.$router.push({
              name: 'progressQuery'
            })
          }
        })
      }
    },

    // 判断当前环境是否在app内
    isApp() {
      return /jzh$/.test(navigator.userAgent.toLowerCase())
    },

    // 点击去支付
    async gopay() {
      if (this.ispay === 1) {
        if (this.isInApp) {
          this.$api.getClassId(this.getcardList.id).then((res) => {
            if (res.code === 0) {
              const _d = JSON.stringify({
                p: {
                  courseIds: `${this.getcardList.id}-${res.data.classId}`,
                  productType: 100
                }
              })
              window.location.href = `xeswangxiao://xrsApp?m=xesmallOrderConfirm&en=0&d=${_d}`
            }
          })
        } else {
          console.log(88888, this.getcardList.id)
          this.$api.getPayUrl(this.getcardList.id).then((res) => {
            if (res.code === 0) {
              window.location.href = res.data.buyUrl
            } else if (res.code === 2) {
              this.$toast('已报满 正在紧急加开名额')
            } else {
              this.$toast(res.data.message)
            }
          })
        }
      } else if (this.ispay === 2) {
        // this.payshow = false
        // this.$xesAlert({
        //   title: '提示',
        //   message: '您已完成0元领课，请前往学而思网校APP点击【学习】查看课程'
        // })
      }

      // 点击去支付埋点
      this.$xesLogger.clickMsg({
        params: {
          pageuid: 'activitiesPage6',
          clickid: 5,
          action: 'click_buy3_uv',
          clickname: '点击去支付'
        }
      })
    },
    payok() {
      this.$xesAlert({
        title: '提示',
        message: '您已完成0元领课，请前往学而思网校APP点击【学习】查看课程'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.buy_class {
  width: 100%;
  min-height: 100vh;
  background: #f2f2f2;

  .head {
    width: 100%;
    height: 65px;
    background: #fef0dc;

    .head_p {
      width: 350px;
      padding: 11px 0 0 28px;
      font-size: 13px;
      font-weight: 400;
      font-family: PingFang SC Regular, PingFang SC Regular-Regular;
      line-height: 22px;
      text-align: left;
      color: #6d6963;
    }
  }

  .card {
    width: 100%;
    overflow: hidden;

    .classCard {
      width: 94%;
      margin: 0 auto;
      margin-top: 10px;
      background: #fff;
      border-radius: 4px;

      .title_p {
        width: 100%;
        padding: 20px 26px 0 16px;
        font-size: 16px;
        font-weight: 500;
        color: #212831;
      }

      .text_p {
        width: 100%;
        margin: 12px 0 0 16px;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
        color: #5b6169;
      }

      .level_p {
        width: 100%;
        margin: 12px 0 0 16px;
        font-size: 14px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
        color: #5b6169;
      }

      .teacher_p {
        width: 100%;
        height: 35px;
        margin-top: 16px;

        .teacherdl {
          float: left;
          width: 120px;
          height: 35px;
          margin-left: 16px;

          dt {
            float: left;

            img {
              width: 32px;
              height: 32px;
              border: 1px solid #e0e1ef;
              border-radius: 50%;
            }
          }

          dd {
            float: left;
            margin-left: 6px;

            .typename_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              color: #878e9a;
            }

            .name_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 12px;
              color: #5e617c;
            }
          }
        }

        .teacher_dl {
          float: left;
          width: 120px;
          height: 35px;
          margin-left: 16px;

          dt {
            float: left;

            img {
              width: 32px;
              height: 32px;
              border: 1px solid #e0e1ef;
              border-radius: 50%;
            }
          }

          dd {
            float: left;
            margin-left: 6px;

            .typename_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              color: #878e9a;
            }

            .name_p {
              margin-top: 2px;
              font-size: 12px;
              font-weight: 400;
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 12px;
              color: #5e617c;
            }
          }
        }
      }

      .pay_box {
        width: 90%;
        padding-bottom: 13px;
        margin: 0 auto;
        margin-top: 16px;
        border-top: 1px solid #f2f2f2;

        .surplus_p {
          float: left;
          width: 100px;
          padding: 13px 0 0 0;
          font-size: 12px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 24px;
          color: #5b6169;
          border: 1px soid #ccc;
        }

        .buy_p {
          width: 74px;
          height: 24px;
          margin-left: 240px;
          margin-top: 12px;
          font-size: 13px;
          font-weight: 500;
          line-height: 24px;
          text-align: center;
          color: #fff;
          border-radius: 12px;
        }

        .buy_p_active {
          background: linear-gradient(#e0ad4c 0%, #d69e32 100%);
        }

        .buy_p_unactive {
          background-color: gray;
        }

        .buy_ok {
          width: 74px;
          height: 24px;
          margin-left: 240px;
          margin-top: 12px;
          font-size: 13px;
          font-weight: 500;
          line-height: 24px;
          text-align: center;
          color: #fff;
          background: linear-gradient(#e0ad4c 0%, #d69e32 100%);
          border-radius: 12px;
        }
      }
    }
  }
}
</style>
